import type { Lens } from '@hookform/lenses';
import type { z } from 'zod/v4';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { IxmUserauthV1ContactDetails } from '@interxfi/types/generated/api';
import { getOptionalArraySchema, OptionalField } from '../../../../../components/form/optional-field';
import {
  formValuesToProgramContact,
  getInitialFormValuesForProgramContact,
  ProgramContactGroupForm,
  programContactSchema,
} from './program-contact-group-form';

export const optionalProgramContactGroupSchema = getOptionalArraySchema(programContactSchema);

export type OptionalProgramContactGroupFormValues = z.infer<typeof optionalProgramContactGroupSchema>;

export const defaultOptionalProgramContactGroupFormValues: OptionalProgramContactGroupFormValues = {
  isProviding: false,
  value: [],
};

export function getInitialFormValuesForOptionalProgramContactGroup(
  data: IxmUserauthV1ContactDetails[] | undefined,
): OptionalProgramContactGroupFormValues {
  if (!data || data.length === 0) {
    return defaultOptionalProgramContactGroupFormValues;
  }

  return {
    isProviding: true,
    value: data.map(getInitialFormValuesForProgramContact),
  };
}

export function optionalFormValuesToProgramContactGroup(values: OptionalProgramContactGroupFormValues): IxmUserauthV1ContactDetails[] | undefined {
  if (!values.isProviding || !values.value?.length) {
    return undefined;
  }

  return values.value.map(formValuesToProgramContact);
}

interface OptionalProgramContactGroupFormProps {
  appendLabel: string;
  label: string;
  lens: Lens<OptionalProgramContactGroupFormValues>;
}

export function OptionalProgramContactGroupForm({ appendLabel, label, lens }: OptionalProgramContactGroupFormProps) {
  return (
    <VerticalStack gap={4}>
      <OptionalField<OptionalProgramContactGroupFormValues['value']>
        defaultValue={defaultOptionalProgramContactGroupFormValues.value}
        label={label}
        lens={lens}
      >
        <ProgramContactGroupForm appendLabel={appendLabel} label={undefined} lens={lens.focus('value')} />
      </OptionalField>
    </VerticalStack>
  );
}
